import {
    GET_LANGS,
    GET_LANGS_SUCCESS
} from './constants';

/**
 *
 * @returns {{type: string}}
 */
const getAllLangs = () => ({ type: GET_LANGS });
/**
 *
 * @param langs
 * @returns {{langs: *, type: string}}
 */
const getAllLangsSuccess = langs => ({ type: GET_LANGS_SUCCESS, langs });

export {
    getAllLangs,
    getAllLangsSuccess
};
